module.exports = __webpack_public_path__ + "img/partner04.bbf159da.png";